import React from 'react';
import SEO from '@bradgarropy/gatsby-plugin-seo';
import { Link } from '@reach/router';
import useSiteMetadata from '../hooks/use-site-metadata';

import Layout from '../components/layout';

const TermsOfService = () => {
  const { siteURL } = useSiteMetadata();
  return (
    <Layout>
      <SEO
        title='Terms of Service | Praiser'
        description='Boost your team moral by praising them'
      />
      <div className='px-5 py-24 w-full max-w-2xl text-gray-700 mx-auto'>
        <div className='flex flex-col text-start mb-20 text-justify'>
          <h1 className='sm:text-4xl text-6xl font-bold text-md title-font mb-16 text-gray-900'>
            Terms of Service
          </h1>
          <ol className='list-decimal space-y-8'>
            <li>
              <h2 className='font-bold text-md text-base'>Terms</h2>
              <p>
                By accessing the website at 
                <Link className='text-indigo-600' to={siteURL}>
                  {siteURL}
                </Link>
                , you are agreeing to be bound by these terms of service, all
                applicable laws and regulations, and agree that you are
                responsible for compliance with any applicable local laws. If
                you do not agree with any of these terms, you are prohibited
                from using or accessing this site. The materials contained in
                this website are protected by applicable copyright and trademark
                law.
              </p>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Use License</h2>
              <ol className='list-decimal ml-6 space-y-2'>
                <li>
                  Permission is granted to temporarily download one copy of the
                  materials (information or software) on Praiser's website for
                  personal, non-commercial transitory viewing only. This is the
                  grant of a license, not a transfer of title, and under this
                  license, you may not:
                  <ol className='list-decimal ml-6 space-y-2'>
                    <li> modify or copy the materials; </li>
                    <li>
                      use the materials for any commercial purpose, or for any
                      public display (commercial or non-commercial);
                    </li>
                    <li>
                      attempt to decompile or reverse engineer any software
                      contained on Praiser's website;
                    </li>
                    <li>
                      remove any copyright or other proprietary notations from
                      the materials; or
                    </li>
                    <li>
                      transfer the materials to another person or "mirror" the
                      materials on any other server.
                    </li>
                  </ol>
                </li>
                <li>
                  This license shall automatically terminate if you violate any
                  of these restrictions and may be terminated by Praiser at any
                  time. Upon terminating your viewing of these materials or upon
                  the termination of this license, you must destroy any
                  downloaded materials in your possession whether in electronic
                  or printed format.
                </li>
              </ol>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Disclaimer</h2>
              <ol className='list-decimal ml-6 space-y-2'>
                <li>
                  The materials on Praiser's website are provided on an 'as is'
                  basis. Praiser makes no warranties, expressed or implied, and
                  hereby disclaims and negates all other warranties including,
                  without limitation, implied warranties or conditions of
                  merchantability, fitness for a particular purpose, or
                  non-infringement of intellectual property or other violation
                  of rights.
                </li>
                <li>
                  Further, Praiser does not warrant or make any representations
                  concerning the accuracy, likely results, or reliability of the
                  use of the materials on its website or otherwise relating to
                  such materials or on any sites linked to this site.
                </li>
              </ol>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Disclaimer</h2>
              <p>
                Limitations In no event shall Praiser or its suppliers be liable
                for any damages (including, without limitation, damages for loss
                of data or profit, or due to business interruption) arising out
                of the use or inability to use the materials on Praiser's
                website, even if Praiser or a Praiser authorized representative
                has been notified orally or in writing of the possibility of
                such damage. Because some jurisdictions do not allow limitations
                on implied warranties, or limitations of liability for
                consequential or incidental damages, these limitations may not
                apply to you.
              </p>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>
                Accuracy of materials
              </h2>
              <p>
                The materials appearing on Praiser's website could include
                technical, typographical, or photographic errors. Praiser does
                not warrant that any of the materials on its website are
                accurate, complete or current. Praiser may make changes to the
                materials contained on its website at any time without notice.
                However, Praiser does not make any commitment to update the
                materials.
              </p>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Links</h2>
              <p>
                Praiser has not reviewed all of the sites linked to its website
                and is not responsible for the contents of any such linked site.
                The inclusion of any link does not imply endorsement by Praiser
                of the site. Use of any such linked website is at the user's own
                risk.
              </p>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Modifications</h2>
              <p>
                Praiser may revise these terms of service for its website at any
                time without notice. By using this website you are agreeing to
                be bound by the then current version of these terms of service.
              </p>
            </li>
            <li>
              <h2 className='font-bold text-md text-base'>Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in
                accordance with the laws of India and you irrevocably submit to
                the exclusive jurisdiction of the courts in that State or
                location.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfService;
